<script setup lang="ts">
import MainBreadcrumbs from "../../../ui/components/header/MainBreadcrumbs.vue";
import { useCampaignPlannerStore } from "../store";

const store = useCampaignPlannerStore();
</script>

<template>
	<main-breadcrumbs :breadcrumbs="store.breadcrumbs" />

	<div>
		<router-view />
	</div>
</template>
